import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';  // Pastikan firebase.js sudah ada dan benar
import Cover from './components/Cover';
import SignUp from './components/Auth/SignUp';
import Login from './components/Auth/Login';
import MainDashboard from './components/Dashboard/MainDashboard';
import ClassDashboard from './components/Dashboard/ClassDashboard';
import DataHistoris from './components/DataHistoris';
import AdminConfig from './components/AdminConfig';
import HistoriTeknis from './components/HistoriTeknis';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const [user, setUser] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    // Listener autentikasi Firebase untuk cek status login
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  if (loading) return <div>Loading...</div>;  // Tunggu cek autentikasi selesai

  return (
    <Router>
      <Routes>
        {/* root */}
        <Route path="/" element={<Navigate to="/cover" replace />} />
        
        <Route path="/cover" element={<Cover />} />
        <Route path="/dashboard" element={<MainDashboard />} />
        <Route path="/dashboard/:namaKelas" element={<ClassDashboard />} />

        {/* Halaman Auth */}
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        
        {/* Halaman Protected (hanya untuk user login) */}
        <Route path="/histori" element={<ProtectedRoute allowedRoles={["user", "admin"]}><DataHistoris /></ProtectedRoute>} />
        
        {/* Halaman Admin (hanya untuk admin) */}
        <Route path="/admin/config" element={<ProtectedRoute requiredRole="admin"><AdminConfig /></ProtectedRoute>} />

        {/* Halaman Teknisi (hanya untuk teknisi) */}
        <Route path="/teknisi/historiteknis" element={<ProtectedRoute requiredRole="teknisi"><HistoriTeknis /></ProtectedRoute>} />
      </Routes>
    </Router>
  );
}

export default App;